var stockists = new function () {
    this.map; // Google map instance
    this.mapLoaded = false;
    this.infoWindow; // Google Infowindow instance
    this.allStockists; // All stockist data always loaded
    this.location; // User's location, if set
    this.markerClusterer; // Clusterer instance
    this.activeMarker; // The current marker that's shown
    this.geoCodeCache = {};
    this.maxPanelResults = 20;
    this.maxZoom = 16;
    this.defaultZoom = 12; // Zoom to this by default when changing location
    this.minimumStockists = 3; // Zoom out until this number is shown when changing location
    this.defaultLatLng = {lat: 52.6904993, lng: -1.1400571};
    this.myLocationText = 'My location';
    this.markerIcon = 'images/icon/maps/map-pin.png';
    this.markerIconActive = 'images/icon/maps/map-pin-active.png';
    this.markerIconFlogas = 'images/icon/maps/map-pin-flogas.png';
    this.markerIconActiveFlogas = 'images/icon/maps/map-pin-active-flogas.png';
    this.locationMarker; // Marker to show user's location
    this.locationMarkerIcon = 'images/icon/maps/map-pin-location.png';
    this.invalidAddress = false;

    this.setMap = function () {
        $('.stockists').prepend('<div class="flogas-loading"></div>');
        this.map = new google.maps.Map(document.getElementById('stockists-map'), {
            center: this.defaultLatLng,
            zoom: 6,
            gestureHandling: 'greedy',
            streetViewControl: false,
            fullscreenControl: false,
            mapTypeControl: false,
            styles: [
                {
                    featureType: 'poi',
                    stylers: [{visibility: 'off'}]
                },
                {
                    featureType: 'administrative.neighborhood',
                    stylers: [{visibility: 'off'}]
                },
                {
                    featureType: 'transit',
                    elementType: 'labels.icon',
                    stylers: [{visibility: 'off'}]
                }
            ]
        });
        this.mapLoaded = true;
        this.map.addListener('dragend', function() {
            stockists.setMapChange();
        });
        this.map.addListener('zoom_changed', function() {
            stockists.setMapChange();
        });
        this.infoWindow = new google.maps.InfoWindow();
        $('.stockists-list').mCustomScrollbar();
        this.setLoading();
        this.doLoad();
    };
    this.doSearch = function (event, el, stateChange) {
        if (typeof stateChange == 'undefined') stateChange = true;
        var address = $('.stockists-form input[name="address"]').val().trim();
        if (address.length > 2) {
            $('.stockists-form__reset-search, .stockists-mobile-view-buttons').removeClass('hide');
            $('.stockists-form__get-location, .stockists-form__do-search').addClass('hide');
            stockists.setInvalidAddress(false);
            stockists.setMapHeight();
            stockists.doResetMarker();
            stockists.setMarkers();
            var $form = $('.stockists-form'),
                cylinders = $form.find('input[name="cylinders"]').is(':checked'),
                gaslight = $form.find('input[name="gaslight"]').is(':checked'),
                autogas = $form.find('input[name="autogas"]').is(':checked'),
                depot = $form.find('input[name="depot"]').is(':checked');
            ga4Event('stockist_search', { address: $('.stockists-form__address-locality').val(), cylinders: cylinders, gaslight: gaslight, autogas: autogas, depot: depot });
            if (address == stockists.myLocationText) {
                stockists.setFormClasses();
                if (typeof stockists.geoCodeCache[address] == 'undefined') {
                    stockists.setCurrentLocation();
                } else {
                    stockists.setLocation(stockists.myLocationText);
                }
                if (stateChange) listFilter.doStateChange();
            } else if (address.length > 2) {
                if (typeof stockists.geoCodeCache[address] != 'undefined') {
                    stockists.setFormClasses();
                    stockists.setLocation(address);
                    if (stateChange) listFilter.doStateChange();
                } else {
                    var geocoder = new google.maps.Geocoder(),
                        postalTown = '',
                        politicalArea = '';
                    geocoder.geocode({'address': address, 'componentRestrictions': {'country': 'GB'}}, function (results, status) {
                        var errorMessage = 'We could not find that location, please check your spelling or try another location.';
                        if (status === 'OK' && results[0].partial_match === true) {
                            stockists.setInvalidAddress(true, errorMessage)
                            console.log('Geocode was not successful for the following reason: partial_match is true');
                        } else if (status === 'OK') {
                            $.each(results[0].address_components, function(i, address_component) {
                                if (address_component.types.indexOf('postal_town') != -1) {
                                    postalTown = address_component.long_name;
                                }
                                if (address_component.types.indexOf('political') != -1 && address_component.types.indexOf('administrative_area_level_2') != -1) {
                                    politicalArea = address_component.long_name;
                                }
                            });
                            stockists.geoCodeCache[address] = {title: address, lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng(), locality: (postalTown.length ? postalTown : politicalArea)};
                            stockists.setLocation(address);
                            if (stateChange) listFilter.doStateChange();
                        } else {
                            stockists.setInvalidAddress(true, errorMessage);
                            console.log('Geocode was not successful for the following reason: ' + status);
                        }
                        stockists.setFormClasses();
                    });
                }
            }
        }
    };
    this.doFilter = function (event, el) {
        if (stockists.location) {
            this.doSearch();
        }
    };
    this.setMapChange = function () {
        if (stockists.map.getZoom() > 10) {
            stockists.setListPanel(stockists.map.getCenter())
        } else if (!stockists.activeMarker && !stockists.location) {
            stockists.setListPanel(); // Clear list panel
        }
    };
    this.setCurrentLocation = function (event, el) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                stockists.location = {
                    locality: stockists.myLocationText,
                    title: stockists.myLocationText,
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                stockists.geoCodeCache[stockists.myLocationText] = stockists.location;
                $('.stockists-form__address').val(stockists.myLocationText).trigger('keyup');
                stockists.doSearch();
            }, function (error) {
                stockists.setCurrentLocationError();
            });
        } else {
            stockists.setCurrentLocationError();
        }
    };
    this.setCurrentLocationError = function () {
        $('.stockists-form__get-location').addClass('hide');
        $('.stockists-form__filters-container').before('<div class="stockists-location-error">Your location could not be determined</div>');
        $('.stockists-location-error').delay(3000).fadeOut(200);
    };
    this.setLocation = function (address) {
        var location = stockists.geoCodeCache[address];
        stockists.location = {
            title: location.title,
            lat: location.lat,
            lng: location.lng
        };
        $('.stockists-form__address-locality').val(location.locality);
        $('.stockists-form__submit').attr('data-gtm-label', location.locality);
        stockists.map.setCenter(stockists.getLatLng(location));
        stockists.map.setZoom(stockists.defaultZoom);
        if (typeof stockists.locationMarker != 'undefined') {
            stockists.locationMarker.setMap(null);
        }
        stockists.locationMarker = new google.maps.Marker({
            map: stockists.map,
            position: stockists.getLatLng(location),
            icon: stockists.locationMarkerIcon
        });
        stockists.setLocationZoom();
        stockists.doResetMarker();
        stockists.setDistances();
        stockists.setListPanel(stockists.location);
    };
    this.setLocationZoom = function () {
        var bounds = stockists.map.getBounds(),
            count = 0;
        for (var i = 0; i < stockists.markers.length; i++) {
            if (bounds.contains(stockists.markers[i].getPosition())) {
                count ++;
            }
        }
        if (count < stockists.minimumStockists) {
            var currentZoom = stockists.map.getZoom();
            stockists.map.setZoom(currentZoom - 1);
            if (currentZoom > 1) {
                stockists.setLocationZoom();
            }
        }
    };
    this.doLoad = function () {
        this.setLoading(true);
        var $stockistList = $('.stockists'),
            ajaxData = {
                action: 'flogas_stockists_get',
                _wpnonce: $stockistList.data('nonce')
            };
        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'json',
            data: ajaxData,
            success: function (json) {
                stockists.allStockists = json;
                stockists.setMarkers();
                stockists.setLoading(false);
                if ($('.stockists-form__address').val().trim().length) {
                    $('.stockists-form').submit();
                } else {
                    stockists.setMapHeight();
                }
            }
        });
    };
    this.setMarkers = function () {
        var $form = $('.stockists-form'),
            cylinders = $form.find('input[name="cylinders"]').is(':checked'),
            gaslight = $form.find('input[name="gaslight"]').is(':checked'),
            autogas = $form.find('input[name="autogas"]').is(':checked'),
            depot = $form.find('input[name="depot"]').is(':checked'),
            marker;
        if (!stockists.markers) {
            stockists.markers = stockists.allStockists.map(function (stockist, i) {
                marker = new google.maps.Marker({
                    position: {lat: stockist.lat, lng: stockist.lng},
                    icon: (stockist.depot ? stockists.markerIconFlogas : stockists.markerIcon)
                });
                stockists.bindInfoWindow(marker, i);
                return marker;
            });
            stockists.markerClusterer = new MarkerClusterer(stockists.map, stockists.markers, {
                imagePath: '/images/icon/maps/cluster-',
                minimumClusterSize: 3,
                ignoreHidden: true
            });
        } else {
            $.each(stockists.markers, function (i, marker) {
                var stockist = stockists.allStockists[i],
                    visible = (cylinders && stockist.cylinders) || (gaslight && stockist.gaslight) || (autogas && stockist.autogas) || (depot && stockist.depot);
                if (!cylinders && !gaslight && !autogas && !depot) visible = true;
                stockists.markers[i].setVisible(visible);
            });
            stockists.markerClusterer.repaint();
        }
    };
    this.getInfoWindow = function (id) {
        var stockist = this.allStockists[id],
            infoWindow = '<a href="/stockists/' + stockist.slug + '" class="loc-link">' +
                '<div class="loc-name">' + stockist.name + '</div>' +
                '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 40 64" xml:space="preserve" style="fill: #ffffff">' +
                '<path class="flogas-icon flogas-icon--foreground" d="M28.6,32.1L0,5.4l5.7-5.3l28.6,26.7l0,0l5.7,5.3l0,0l0,0l-5.7,5.3l0,0L5.7,64.1L0,58.7L28.6,32.1z"/>' +
                '</svg>';
        if (stockist.distance && stockists.location) {
            infoWindow += '<div class="loc-dist">' + stockist.distance + ' mile' + (stockist.distance != 1 ? 's' : '') + ' from <span>' + stockists.location.title + '</span></div>';
        }
        infoWindow += '</a>';
        return infoWindow;
    };
    this.setListPanel = function (filterLocation) {
        $('.stockists-list__list, .stockists-form__count').html('');
        $('.stockists-mobile-view-buttons').addClass('hide');
        if (filterLocation) {
            var activeInList = false,
                count = 0;
            $.each(stockists.getListPanelStockists(filterLocation), function (i, stockist) {
                $('.stockists-list__list').append(stockists.getStockistPanel(stockist));
                if (stockists.activeMarker == stockist.index) activeInList = true;
                count ++;
            });
            if (count > 0) {
                $('.stockists-mobile-view-buttons').removeClass('hide');
                stockists.setMapHeight(0);
                $('.stockists-form__count').html(count + ' stockist' + (count != 1 ? 's' : '') + (filterLocation.title ? ' around <strong>' + filterLocation.title + '</strong>' : ''));
                $('.stockists-list').mCustomScrollbar('scrollTo', (activeInList && stockists.activeMarker ? '.list-focus' : 0));
            } else {
                var autogas = $('.stockists-form').find('input[name="autogas"]').is(':checked');
                $('.stockists-list__list').html('<li class="stockists-list__list-none">' + (autogas ? noResultsTextAutogas : noResultsText) + '</li>');

            }
        }
    };
    this.doSelect = function (event, el) {
        var stockistIndex = $(el).data('stockistIndex'),
            marker = stockists.markers[stockistIndex];
        if (marker.map) {
            new google.maps.event.trigger(stockists.markers[stockistIndex], 'click');
        } else { // in a cluster
            var newZoom = stockists.map.getZoom() + 1,
                stockist = stockists.allStockists[stockistIndex];
            if (newZoom <= stockists.maxZoom) {
                stockists.map.setCenter({lat: stockist.lat, lng: stockist.lng});
                stockists.map.setZoom(newZoom);
                setTimeout(function () {
                    $('.loc-name[data-stockist-index="' + stockistIndex + '"]').trigger('click');
                }, 600);
            }
        }
        this.doMobileViewMap();
    };
    this.getStockistPanel = function (stockist) {
        var stockistPanel = '<li class="list-item' + (stockist.active ? ' list-focus' : '') + '">';
        stockistPanel += '<div class="list-details"><div class="loc-name' + (stockist.depot ? ' is-depot' : '') + '" data-click="stockists:doSelect" data-stockist-index="' + stockist.index + '"><h4>' + stockist.name + '</h4>';
        if (stockist.distance && stockists.location) {
            stockistPanel += '<div class="loc-dist">' + stockist.distance + ' mile' + (stockist.distance != 1 ? 's' : '') + ' from <span>' + stockists.location.title + '</span></div>';
        }
        stockistPanel += '<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" class="svg-inline--fa fa-chevron-right fa-w-8 fa-3x"><path fill="currentColor" d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z" class=""></path></svg>';
        if (stockist.depot) {
            stockistPanel += '<img src="/images/logo-white-outline.svg" class="logo" alt="Flogas">';
        }
        if (stockist.closed) {
            stockistPanel += '<span class="free-delivery">Closed</span>';
        }

        stockistPanel += '</div>';
        stockistPanel += '<div class="list-content">';
        stockistPanel += '<div class="list-content-text">';
        stockistPanel += '<div class="list-content-left">';
        stockistPanel += '<div class="loc-addr"><h5>Address</h5>' + stockist.address1 + '</div>';
        stockistPanel += '<div class="loc-addr2">' + stockist.address2 + '</div>';
        stockistPanel += '<div class="loc-addr3">' + stockist.address3 + '</div>';
        stockistPanel += '</div>';
        if (stockist.cylinders || stockist.autogas || stockist.gaslight) {
            stockistPanel += '<div class="list-content-right">';

            stockistPanel += '<div><h5>Products we stock</h5></div>';
            if (stockist.cylinders) {
                stockistPanel += '<div class="prod cylinders"><span>Cylinders</span></div>';
            }
            if (stockist.autogas) {
                stockistPanel += '<div class="prod autogas"><span>Autogas</span>';
                if (stockist.autogasKeyRequired) {
                    stockistPanel += '<br><span class="key-required">Key required</span>';
                }
                stockistPanel += '</div>';
            }
            if (stockist.gaslight) {
                stockistPanel += '<div class="prod gaslight"><span>Gaslight</span></div>';
            }
            stockistPanel += '</div>';
        }
        stockistPanel += '</div>';
        stockistPanel += '<a href="/stockists/' + stockist.fn + '" class="button button--secondary button--align-wide"><span class="button__inner">View stockist</span></a>';
        stockistPanel += '</div>';
        stockistPanel += '</div>';
        stockistPanel += '</li>';
        return stockistPanel;
    };
    this.getListPanelStockists = function (filterLocation) {
        var listStockists = [],
            $form = $('.stockists-form'),
            cylinders = $form.find('input[name="cylinders"]').is(':checked'),
            gaslight = $form.find('input[name="gaslight"]').is(':checked'),
            autogas = $form.find('input[name="autogas"]').is(':checked'),
            depot = $form.find('input[name="depot"]').is(':checked'),
            stockist,
            visible,
            bounds = stockists.map.getBounds();
        for (var i = 0; i < stockists.markers.length; i++) {
            if (bounds.contains(stockists.markers[i].getPosition())) {
                stockist = stockists.allStockists[i];

                visible = (cylinders && stockist.cylinders) || (gaslight && stockist.gaslight) || (autogas && stockist.autogas) || (depot && stockist.depot);
                if (!cylinders && !gaslight && !autogas && !depot) visible = true;
                if (visible) {
                    stockist.index = i;
                    stockist.active = (stockists.activeMarker && stockists.activeMarker == i);
                    stockist.distanceFromFilter = stockists.getDistance(filterLocation, stockist);
                    listStockists.push(stockist);
                }
            }
        }
        listStockists.sort(function (a, b) {
            return (a.distanceFromFilter > b.distanceFromFilter ? 1 : -1);
        });
        if (listStockists.length > stockists.maxPanelResults) {
            listStockists = listStockists.slice(0, stockists.maxPanelResults)
        }
        return listStockists;
    };
    this.getLatLng = function (object) {
        return new google.maps.LatLng(object.lat, object.lng)
    };
    this.getDistance = function (from, to) {
        var distance = google.maps.geometry.spherical.computeDistanceBetween(stockists.getLatLng(from), stockists.getLatLng(to)); // in meters
        distance /= 1000; // KM
        distance *= 0.621371; // Miles
        return Math.round(distance * 10) / 10; // to 1 d.p.llStockists[i].distance = Math.round(distance * 10) / 10;
    };
    this.setDistances = function () {
        $.each(stockists.allStockists, function (i, stockist) {
            stockists.allStockists[i].distance = stockists.getDistance(stockists.location, stockist);
        });
    };
    this.doResetMarker = function () {
        $('.list-item').removeClass('list-focus');
        if (stockists.activeMarker) {
            stockists.infoWindow.close();
            stockists.markers[stockists.activeMarker].setIcon((stockists.allStockists[stockists.activeMarker].depot ? stockists.markerIconFlogas : stockists.markerIcon));
            stockists.activeMarker = null;
        }
    };
    this.bindInfoWindow = function (marker, id) {
        google.maps.event.addListener(marker, 'click', function () {
            if (stockists.activeMarker != id) {
                stockists.infoWindow.setContent(stockists.getInfoWindow(id));
                stockists.infoWindow.open(stockists.map, marker);
                if (stockists.activeMarker) {
                    stockists.markers[stockists.activeMarker].setIcon((stockists.allStockists[stockists.activeMarker].depot ? stockists.markerIconFlogas : stockists.markerIcon));
                }
                stockists.activeMarker = id;
                stockists.setListPanel(stockists.allStockists[id]);
                marker.setIcon((stockists.allStockists[id].depot ? stockists.markerIconActiveFlogas : stockists.markerIconActive));
                if ($(window).width() < 768) {
                    $('.stockists-mobile-view-buttons .button.show-list').trigger('click');
                }
            } else {
                stockists.doResetMarker();
            }
        });
    };
    this.setLoading = function (loading) {
        var $loading = $('.stockists .flogas-loading');
        $loading.height($('.stockists__map').height());
        $loading[(loading ? 'remove' : 'add') + 'Class']('hide');
    };
    this.doChangeLocation = function (event, el) {
        if (!event || event.type !== 'keyup' || event.key !== 'Enter') {
            var hasLocation = $('.stockists-form__address').val().length > 2;
            $('.stockists-form__address').next('label')[(hasLocation ? 'add' : 'remove') + 'Class']('has_val');
            $('.stockists-form__reset-search').addClass('hide');
            $('.stockists-form__do-search')[(hasLocation ? 'remove' : 'add') + 'Class']('hide');
            $('.stockists-form__get-location')[(hasLocation ? 'add' : 'remove') + 'Class']('hide');
        }
    };
    this.doReset = function (event, el) {
        this.setInvalidAddress(false);
        $('.stockists-form__address, .stockists-form__address-locality').val('');
        this.doResetFilter();
        listFilter.doStateChange();
        this.doChangeLocation();
        this.setListPanel(null);
        stockists.doResetMarker();
        this.location = null;
        this.setFormClasses();
        this.setMapHeight();
    };
    this.doToggleFilter = function (event, el) {
        $('.stockists-form__filters-container').toggleClass('slide-out-open');
    };
    this.doResetFilter = function (event, el) {
        $('.stockists-form__filters-container').find('input:checked').prop('checked', false);
        $('.stockists-form').submit();
    };
    this.doMobileViewMap = function (event, el) {
        $('.stockists-mobile-view-button--map').addClass('is-selected');
        $('.stockists-mobile-view-button--list').removeClass('is-selected');
        $('.stockists-map').addClass('mobile-open').removeClass('mobile-closed');
        $('.stockists-list').removeClass('mobile-open').addClass('mobile-closed');
        $('.stockists-form').addClass('mobile-closed');
        stockists.setMapHeight();
    };
    this.doMobileViewList = function (event, el) {
        $('.stockists-mobile-view-button--map').removeClass('is-selected');
        $('.stockists-mobile-view-button--list').addClass('is-selected');
        $('.stockists-map').removeClass('mobile-open').addClass('mobile-closed');
        $('.stockists-list').addClass('mobile-open').removeClass('mobile-closed');
        $('.stockists-form').addClass('mobile-closed');
    };
    this.doMobileFormToggle = function (event, el) {
        $('.stockists-form').toggleClass('mobile-closed');
        $('.stockists__map').toggleClass('mobile-form-closed');
        stockists.setMapHeight();
    };
    this.getFiltersQueryString = function () {
        var filtersQueryString = '';
        if ($('#cylinders-filter').is(':checked')) filtersQueryString += 'cylinders,';
        if ($('#gaslight-filter').is(':checked')) filtersQueryString += 'gaslight,';
        if ($('#autogas-filter').is(':checked')) filtersQueryString += 'autogas,';
        if ($('#depot-filter').is(':checked')) filtersQueryString += 'depot,';
        if (filtersQueryString.length) {
            return '&filters=' + filtersQueryString.substr(0, (filtersQueryString.length - 1));
        }
        return '';
    };
    this.setFormClasses = function (event, el) {
        if (!this.invalidAddress && $('.stockists-form__address').val().trim().length) {
            $('.stockists-form, .stockists__sidebar, .stockists__map').addClass('has_val');
            $('.stockists-form__filters-container').addClass('closed slide-out');
        } else {
            $('.stockists-form, .stockists__sidebar, .stockists__map').removeClass('has_val');
            $('.stockists-form__filters-container').removeClass('closed slide-out');
        }
    };
    this.setInvalidAddress = function (state, message) {
        this.invalidAddress = !!state;
        var $addressField = $('.stockists-form input[name="address"]');
        $addressField.closest('.input-wrapper').parent().children('div.alert').remove();
        if (state && message) {
            $addressField.closest('.input-wrapper').after('<div class="alert alert-danger">' + message + '</div>');
        }
    }
    this.setMapHeight = function (delay) {
        var windowWidth = $(window).width();
        if (typeof delay == 'undefined') delay = 500;
        if (windowWidth < 768) {
            setTimeout(function () {
                var windowHeight = $(window).height(),
                    mapHeight;
                $('.stockists__map').css('margin', 'auto').css('height', 'auto');
                mapHeight = windowHeight - $('.header').outerHeight() - $('.stockists-form').outerHeight() - $('.stockists-mobile-view-buttons').outerHeight();

                //if (!$('.stockists-mobile-view-buttons').hasClass('hide')) mapHeight -=
                $('.stockists__map').css('marginTop', $('.stockists-form').outerHeight()).css('height', mapHeight);
            }, delay);
        }
    };
    this.setFiltersFromUrl = function () {
        var $form = $('.stockists-form'),
            filters = listFilter.getParameterByName('filters');
        if (filters) {
            $form.find('input[name="cylinders"]').prop('checked', filters.indexOf('cylinders') != -1);
            $form.find('input[name="gaslight"]').prop('checked', filters.indexOf('gaslight') != -1);
            $form.find('input[name="autogas"]').prop('checked', filters.indexOf('autogas') != -1);
        } else {
            $form.find('input[name="cylinders"]').prop('checked', false);
            $form.find('input[name="gaslight"]').prop('checked', false);
            $form.find('input[name="autogas"]').prop('checked', false);
        }
        if (!filters && !$('.stockists-form__address').val().trim().length && stockists.activeMarker == null) {
            // no searches at all, reset
            this.doReset(null, null);
        } else {
            this.doSearch(null, null, false);
        }
    };
};
$(function () {
    setTimeout(function () {
        $(window).on('mousemove scroll keydown touchstart', function() {
            if (!stockists.mapLoaded) {
                stockists.setMap();
            }
        });
    }, 200)

    $(window).resize(function () {
        $('.stockists-form__filters-container').removeClass('slide-out-open');
    });
});
listFilter.setVariables({
    location: {queryString: true, identifier: '.stockists-form__address-locality'},
    filters: {queryString: true, identifier: '.stockists-form__checkbox-filter', getData: 'stockists.getFiltersQueryString'}
});
window.onpopstate = function(event) {
    listFilter.setParamsFromUrl();
    stockists.setFiltersFromUrl();
};

$(window).on('resize', function(){
    stockists.setMapHeight(0);
});